import { activityFetch as fetch } from '../../components/feedback/requestActivity'
import { titleTheme,pageTheme,headerTheme,subTheme,contentTheme,cardTheme} from '../../components/consoleTheme'


import { useState, useEffect, useCallback, Fragment } from "react"
import styled from "styled-components"
import {
  MonitorPlay, Server, CheckCircle2, DownloadCloud, Play, ArrowLeft, RefreshCw,
  Plug, AlertCircle, Loader2, ExternalLink, HelpCircle, KeyRound, Wifi,
} from "lucide-react"

const API = "/api/rtremote"
function getToken() { return sessionStorage.getItem("token") || localStorage.getItem("token") }
function authHeaders(json = true) {
  const h = {}; if (json) h["Content-Type"] = "application/json"
  const t = getToken(); if (t) h["Authorization"] = `Bearer ${t}`; return h
}

const Page = styled.div`
 ${pageTheme}
padding:0; background:#f8fafc; min-height:100vh;`
const Header = styled.header`
 ${headerTheme}
display:flex; align-items:center; justify-content:space-between; padding:1rem 2rem; background:#fff; border-bottom:1px solid #e2e8f0;@media(max-width:768px){padding:1rem;flex-wrap:wrap;gap:.75rem;}`
const Title = styled.h1`
 ${titleTheme}
font-size:1.25rem; font-weight:600; color:#1e293b; display:flex; align-items:center; gap:.5rem;`
const Sub = styled.p`
 ${subTheme}
margin:.25rem 0 0; font-size:.8rem; color:#94a3b8;`
const Content = styled.div`
 ${contentTheme}
padding:2rem; max-width:680px; margin:0 auto;@media(max-width:768px){padding:1rem;}`

const Steps = styled.div`display:flex; align-items:center; gap:0; margin-bottom:2rem;`
const Dot = styled.button`
  display:flex; flex-direction:column; align-items:center; gap:6px; background:none; border:none; cursor:${(p) => (p.clickable ? "pointer" : "default")}; flex:1;
  .c{width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:14px;
     background:${(p) => p.state === "done" ? "#16a34a" : p.state === "active" ? "var(--accent)" : "#e2e8f0"};
     color:${(p) => (p.state === "upcoming" ? "#94a3b8" : "#fff")};}
  .l{font-size:12px;color:${(p) => p.state === "active" ? "var(--accent)" : p.state === "done" ? "#16a34a" : "#94a3b8"};font-weight:${(p) => (p.state === "active" ? 700 : 500)};}
`
const Bar = styled.div`height:2px; flex:0 0 24px; background:${(p) => (p.done ? "#16a34a" : "#e2e8f0")};`

const Signals = styled.div`display:flex; gap:.6rem; flex-wrap:wrap; margin-bottom:1.4rem;`
const LightBox = styled.div`
  flex:1; min-width:150px; display:flex; align-items:center; gap:.7rem; padding:.8rem .95rem; border-radius:12px; background:#fff; border:1px solid #e2e8f0;
  .d{width:14px; height:14px; border-radius:50%; flex-shrink:0;}
  .t{font-size:.85rem; font-weight:700; color:#1e293b;}
  .s{font-size:.75rem; color:#94a3b8; margin-top:1px;}
`
const Card = styled.div`
 ${cardTheme}
background:#fff; border:1px solid #e2e8f0; border-radius:14px; padding:1.75rem; box-shadow:0 1px 3px rgba(0,0,0,.04);@media(max-width:768px){padding:1rem;}`
const StepH = styled.h2`font-size:1.15rem; font-weight:700; color:#1e293b; margin:0 0 .4rem;`
const StepP = styled.p`font-size:.9rem; color:#64748b; margin:0 0 1.25rem; line-height:1.6;`
const Big = styled.button`
  width:100%; padding:1rem; border-radius:10px; border:none; cursor:pointer; font-size:1rem; font-weight:700;
  display:flex; align-items:center; justify-content:center; gap:.5rem;
  background:${(p) => (p.green ? "#16a34a" : "var(--accent)")}; color:#fff;
  &:hover{filter:brightness(.95);} &:disabled{opacity:.5;cursor:default;}
`
const Ghost = styled.button`
  width:100%; padding:.8rem; border-radius:10px; cursor:pointer; font-size:.92rem; font-weight:600; margin-top:.6rem;
  background:#fff; color:#64748b; border:1px solid #e2e8f0; display:flex; align-items:center; justify-content:center; gap:.5rem;
  &:hover{border-color:var(--accent);color:var(--accent);} &:disabled{opacity:.5;}
`
const HostItem = styled.button`
  width:100%; display:flex; align-items:center; gap:.9rem; padding:1rem; margin-bottom:.6rem; cursor:pointer; text-align:left;
  background:${(p) => (p.sel ? "#eff6ff" : "#fff")}; border:1.5px solid ${(p) => (p.sel ? "var(--accent)" : "#e2e8f0")}; border-radius:12px;
  &:hover{border-color:var(--accent);}
  .nm{font-weight:600;color:#1e293b;} .ad{font-size:.8rem;color:#94a3b8;font-family:ui-monospace,monospace;}
`
const Status = styled.div`
  display:flex; align-items:center; gap:.6rem; padding:.9rem 1rem; border-radius:10px; font-size:.92rem; font-weight:600; margin-bottom:1rem;
  background:${(p) => p.ok ? "#f0fdf4" : p.bad ? "#fef2f2" : "#f8fafc"};
  border:1px solid ${(p) => p.ok ? "#bbf7d0" : p.bad ? "#fecaca" : "#e2e8f0"};
  color:${(p) => p.ok ? "#166534" : p.bad ? "#991b1b" : "#475569"};
`
const Note = styled.div`display:flex; gap:.6rem; padding:.8rem 1rem; border-radius:10px; font-size:.84rem; line-height:1.55; background:#fffbeb; border:1px solid #fde68a; color:#92400e; margin-top:1rem;`
const Empty = styled.div`text-align:center; color:#94a3b8; font-size:.9rem; padding:1.5rem;`
const Mono = styled.code`font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.82rem; color:#334155;`
const Help = styled.div`margin-top:1.25rem; border-top:1px dashed #e2e8f0; padding-top:1rem;`
const HelpToggle = styled.button`background:none;border:none;color:#94a3b8;font-size:.82rem;cursor:pointer;display:flex;align-items:center;gap:6px;&:hover{color:var(--accent);}`
const Spin = styled(Loader2)`animation:spin 1s linear infinite; @keyframes spin{to{transform:rotate(360deg)}}`
const Input = styled.input`padding:.6rem .8rem; border:1px solid #e2e8f0; border-radius:8px; outline:none; font-size:1rem; text-align:center; letter-spacing:4px; width:120px; &:focus{border-color:var(--accent);}`

const RtRemote = () => {
  const [step, setStep] = useState(1)
  const [hosts, setHosts] = useState([])
  const [loadingHosts, setLoadingHosts] = useState(true)
  const [sel, setSel] = useState(null)            // node_id
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState(null)
  const [showHelp, setShowHelp] = useState(false)
  const [credForm, setCredForm] = useState({ ssh_user: "root", secret_type: "password", ssh_secret: "" })
  const [clientInstalled, setClientInstalled] = useState(() => localStorage.getItem("rt_client_installed") === "1")
  const markClientInstalled = () => { localStorage.setItem("rt_client_installed", "1"); setClientInstalled(true); go(4) }

  const inp = { padding: ".6rem .8rem", border: "1px solid #e2e8f0", borderRadius: 8, outline: "none", fontSize: ".9rem", flex: 1, fontFamily: "inherit" }
  const selHost = hosts.find((h) => h.address === sel)   // sel = 호스트 주소(가상IP)

  const loadHosts = useCallback(async () => {
    setLoadingHosts(true)
    try { const d = await fetch(`${API}/hosts`, { headers: authHeaders(false), credentials: "include" }).then((x) => x.json()); setHosts(d.hosts || []) }
    catch (_) {} finally { setLoadingHosts(false) }
  }, [])
  useEffect(() => { loadHosts() }, [loadHosts])

  // STEP 2: 상태 확인 / 스트리밍 켜기
  //
  // 목록이 준 status 는 마지막으로 알려진 값이라 오래됐을 수 있다. 그걸
  // 그대로 초록불로 보여주면 터널조차 없는 PC 가 "준비됨" 으로 뜬다
  // (실측 2026-08-20: 100.77.7.2 는 허브에 핸드셰이크 기록이 없는데 초록).
  // 그래서 PC 를 고르는 순간 실제로 물어본다.
  //
  // 의존성에 hosts 를 두면 안 된다 — setHosts 가 새 배열을 만들고, 그것이
  // 다시 이 함수를 새로 만들어 effect 가 또 돌아 무한히 요청한다.
  // sel 이 곧 주소이므로 hosts 를 볼 이유도 없다.
  const checkStatus = useCallback(async () => {
    if (!sel) return
    try {
      const d = await fetch(`${API}/hosts/addr/${encodeURIComponent(sel)}/status`, { headers: authHeaders(false), credentials: "include" }).then((x) => x.json())
      setHosts((hs) => hs.map((h) => h.address === sel ? { ...h, status: d.active ? "ready" : "stopped" } : h))
    } catch (_) {}
  }, [sel])
  useEffect(() => { if (sel) checkStatus() }, [sel, checkStatus])


  const turnOnStreaming = async () => {
    if (!selHost?.node_id) return
    setBusy(true); setMsg(null)
    try {
      const d = await fetch(`${API}/hosts/${selHost.node_id}/install`, { method: "POST", headers: authHeaders(false), credentials: "include" }).then((x) => x.json())
      if (d.ok) {
        setHosts((hs) => hs.map((h) => h.address === sel ? { ...h, status: "ready" } : h))
        setMsg({ ok: true, text: "스트리밍 호스트 준비 완료!" })
      } else setMsg({ ok: false, text: d.message || d.error || "설치 실패 — 호스트가 켜져 있고 디스플레이/GPU가 있는지 확인하세요." })
    } catch (e) { setMsg({ ok: false, text: e.message }) } finally { setBusy(false) }
  }

  // 피어(자동발견) 호스트 → 로그인 정보 받아 노드 등록 후 스트리밍 설치
  const registerAndInstall = async () => {
    if (!selHost) return
    if (!credForm.ssh_secret) { setMsg({ ok: false, text: "그 PC의 로그인 정보를 입력하세요." }); return }
    setBusy(true); setMsg(null)
    try {
      let nodeId = selHost.node_id
      if (!nodeId) {
        const res = await fetch(`/api/storage/nodes`, {
          method: "POST", headers: authHeaders(), credentials: "include",
          body: JSON.stringify({ name: selHost.name, address: selHost.address, ssh_user: credForm.ssh_user, ssh_port: "22", secret_type: credForm.secret_type, ssh_secret: credForm.ssh_secret }),
        })
        const d = await res.json().catch(() => ({}))
        if (!res.ok || !d.node_id) { setMsg({ ok: false, text: "접속 정보 등록 실패: " + (d.error || "") }); setBusy(false); return }
        nodeId = d.node_id
      } else {
        await fetch(`/api/storage/nodes/${nodeId}`, { method: "PUT", headers: authHeaders(), credentials: "include", body: JSON.stringify({ ssh_user: credForm.ssh_user, secret_type: credForm.secret_type, ssh_secret: credForm.ssh_secret }) })
      }
      setHosts((hs) => hs.map((h) => h.address === selHost.address ? { ...h, node_id: nodeId, has_secret: true, source: "node" } : h))
      const r = await fetch(`${API}/hosts/${nodeId}/install`, { method: "POST", headers: authHeaders(false), credentials: "include" }).then((x) => x.json())
      if (r.ok) { setHosts((hs) => hs.map((h) => h.address === selHost.address ? { ...h, status: "ready" } : h)); setMsg({ ok: true, text: "스트리밍 준비 완료!" }) }
      else setMsg({ ok: false, text: r.message || r.error || "설치 실패 — 그 PC가 켜져 있고 SSH/디스플레이가 되는지 확인하세요." })
    } catch (e) { setMsg({ ok: false, text: e.message }) } finally { setBusy(false) }
  }

  // STEP 4: 접속 + 자동 페어링(PIN 입력 0회)
  const connect = () => { if (selHost) window.location.href = `rtremote://${selHost.address}` }
  const autoPair = async () => {
    if (!selHost?.address) { setMsg({ ok: false, text: "호스트를 먼저 선택하세요." }); return }
    if (!ready) { setMsg({ ok: false, text: "먼저 ②단계에서 스트리밍이 준비돼야 합니다." }); return }
    const p = String(1000 + Math.floor(Math.random() * 9000))   // 4자리 PIN 자동 생성
    setBusy(true); setMsg({ ok: true, text: "클라이언트를 여는 중… 페어링까지 최대 20초 정도 걸려요. 잠시 기다리세요." })
    // 1) 클라이언트가 그 PIN으로 페어링 시작 (딥링크)
    window.location.href = `rtremote://${selHost.address}?pin=${p}`
    // 2) 잠시 후 백엔드가 호스트(Sunshine)에 같은 PIN을 재시도하며 등록 → 페어링 완료
    setTimeout(async () => {
      try {
        const d = await fetch(`${API}/hosts/addr/${encodeURIComponent(selHost.address)}/pair`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify({ pin: p }) }).then((x) => x.json())
        if (d.ok) {
          setMsg({ ok: true, text: "페어링 완료! 이제 [접속]을 누르세요." })
        } else {
          // 실패 이유는 서버가 이미 구분해서 준다(no_client / unreachable / unauthorized).
          // 클라가 한 번도 안 뜬 경우에만 설치 기억을 지운다 — 호스트가 꺼져 있어서
          // 실패한 것까지 "다시 설치하세요"로 몰면 엉뚱한 곳을 고치게 된다.
          if (d.reason === "no_client") { localStorage.removeItem("rt_client_installed"); setClientInstalled(false) }
          setMsg({ ok: false, text: d.message || "페어링 실패 — 클라이언트가 안 떴어요. RT Remote가 설치돼 있는지 ③단계에서 확인/설치하세요." })
        }
      } catch (e) { setMsg({ ok: false, text: e.message }) } finally { setBusy(false) }
    }, 1500)
  }

  // 수동 페어링 — 클라이언트가 보여주는 PIN을 콘솔에서 호스트에 등록(어떤 클라 버전이든 동작)
  const [manualPin, setManualPin] = useState("")
  const manualPair = async () => {
    if (!selHost?.address) { setMsg({ ok: false, text: "호스트를 먼저 선택하세요." }); return }
    if (!/^\d{4}$/.test(manualPin)) { setMsg({ ok: false, text: "클라이언트에 뜬 4자리 PIN을 입력하세요." }); return }
    setBusy(true); setMsg({ ok: true, text: "페어링 등록 중…" })
    try {
      const d = await fetch(`${API}/hosts/addr/${encodeURIComponent(selHost.address)}/pair`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify({ pin: manualPin }) }).then((x) => x.json())
      setMsg(d.ok ? { ok: true, text: "페어링 완료! 클라이언트에서 스트리밍이 이어집니다." } : { ok: false, text: "페어링 실패 — 클라이언트에 PIN 창이 떠 있는 동안 입력했는지 확인하세요." })
      if (d.ok) setManualPin("")
    } catch (e) { setMsg({ ok: false, text: e.message }) } finally { setBusy(false) }
  }

  const go = (n) => { setMsg(null); setStep(n) }
  const stepState = (n) => (step === n ? "active" : step > n ? "done" : "upcoming")
  const ready = selHost?.status === "ready"

  return (
    <Page>
      <Header>
        <div><Title><MonitorPlay size={20} /> RT Remote</Title><Sub>안내를 따라 한 단계씩 진행하면 원격 PC에 접속됩니다.</Sub></div>
        <Ghost style={{ width: "auto", padding: ".5rem .9rem", marginTop: 0 }} onClick={loadHosts}><RefreshCw size={14} /> 새로고침</Ghost>
      </Header>
      <Content>
        <Steps>
          {[1, 2, 3, 4].map((n, i) => (
            <Fragment key={n}>
              {i > 0 && <Bar done={step > n - 1} />}
              <Dot state={stepState(n)} clickable={step > n} onClick={() => step > n && go(n)}>
                <span className="c">{step > n ? <CheckCircle2 size={18} /> : n}</span>
                <span className="l">{["접속할 PC", "스트리밍 켜기", "프로그램 설치", "접속"][n - 1]}</span>
              </Dot>
            </Fragment>
          ))}
        </Steps>

        {selHost && (
          <>
          <div style={{ fontSize: ".8rem", color: "#94a3b8", marginBottom: ".5rem" }}>선택한 PC <b style={{ color: "#475569" }}>{selHost.name}</b> 의 준비 상태 (내 콘솔 로그인과는 별개예요)</div>
          <Signals>
            {[
              { st: (selHost.source === "peer" && selHost.peer_status && selHost.peer_status !== "online") ? "warn" : "ok", t: "VPC 연결", s: selHost.address,
                warnFix: "그 PC가 켜져 있고 에이전트가 연결됐는지 확인", warnStep: 1 },
              { st: ready ? "ok" : busy ? "warn" : "bad", t: "스트리밍(호스트)", s: ready ? "준비됨" : busy ? "확인 중…" : "미준비",
                fix: "② 호스트 PC에서 「이 PC 원격 허용」", step: 2 },
            ].map((l, i) => {
              const c = l.st === "ok" ? "#22c55e" : l.st === "warn" ? "#f59e0b" : "#ef4444"
              const action = l.st === "bad" ? l.fix : l.st === "warn" ? l.warnFix : null
              const jump = l.st === "bad" ? l.step : l.st === "warn" ? l.warnStep : null
              return (
                <LightBox key={i} onClick={() => jump && go(jump)}
                  style={{ cursor: jump ? "pointer" : "default", borderColor: l.st === "bad" ? "#fecaca" : l.st === "warn" ? "#fde68a" : "#e2e8f0" }}>
                  <span className="d" style={{ background: c, boxShadow: `0 0 0 4px ${c}22` }} />
                  <div style={{ minWidth: 0 }}>
                    <div className="t">{l.t}</div>
                    <div className="s">{l.s}</div>
                    {action && <div style={{ fontSize: ".74rem", color: l.st === "warn" ? "#b45309" : "var(--accent)", fontWeight: 600, marginTop: 2 }}>→ {action}{jump ? " (클릭)" : ""}</div>}
                  </div>
                </LightBox>
              )
            })}
          </Signals>
          </>
        )}

        <Card>
          {/* STEP 1 — 호스트 선택 */}
          {step === 1 && (
            <>
              <StepH>1. 어느 PC에 접속할까요?</StepH>
              <StepP>아래에서 접속할 PC(호스트)를 고르세요. 목록은 VPC로 연결된 PC들입니다.</StepP>
              {loadingHosts ? <Empty><Spin size={20} /></Empty>
                : hosts.length === 0 ? (
                  <>
                    <Empty>아직 연결된 PC가 없습니다.<br />접속할 PC를 먼저 VPC(네트워크)에 연결해야 해요.</Empty>
                    <Ghost onClick={() => window.open("/network", "_self")}><Wifi size={16} /> 네트워크에서 PC 연결하기</Ghost>
                  </>
                ) : (
                  <>
                    {hosts.map((h) => (
                      <HostItem key={h.address} sel={sel === h.address} onClick={() => setSel(h.address)}>
                        <Server size={20} color={sel === h.address ? "var(--accent)" : "#94a3b8"} />
                        <div style={{ flex: 1 }}>
                          <div className="nm">{h.name} {h.source === "peer" && <span style={{ fontSize: 11, color: "var(--accent)", background: "#eff6ff", padding: "1px 6px", borderRadius: 999 }}>VPC 자동</span>}</div>
                          <div className="ad">{h.address}{h.status === "ready" ? " · 준비됨" : ""}</div>
                        </div>
                        {sel === h.address && <CheckCircle2 size={20} color="var(--accent)" />}
                      </HostItem>
                    ))}
                    <Big style={{ marginTop: ".6rem" }} disabled={!sel} onClick={() => go(2)}>이 PC로 진행 →</Big>
                  </>
                )}
            </>
          )}

          {/* STEP 2 — 스트리밍 켜기 (호스트쪽 앤츠톡) */}
          {step === 2 && selHost && (
            <>
              <StepH>2. 그 PC의 스트리밍 켜기</StepH>
              <StepP><b>{selHost.name}</b> ({selHost.address}) 에 스트리밍(Sunshine)이 준비돼야 합니다.</StepP>
              {ready ? (
                <>
                  <Status ok><CheckCircle2 size={18} /> 스트리밍 준비됨 — 다음으로 진행하세요.</Status>
                  <Big green onClick={() => go(3)}>다음 →</Big>
                </>
              ) : (
                <>
                  <Status><Plug size={18} /> 아직 준비 안 됨.</Status>
                  <Note>
                    <KeyRound size={16} />
                    <span><b>그 PC(호스트)에서</b> 앤츠톡 → 플러그인 → <b>「이 PC 원격 허용」</b> 버튼을 한 번 누르세요.
                      Sunshine이 자동 설치·등록되어 여기 <b>“준비됨”</b>으로 바뀝니다. (다운로드·설치·등록 자동, SSH 불필요)
                      <br />그 PC가 Linux 서버면 스토리지에서 SSH 노드로 등록 후 자동설치도 됩니다.</span>
                  </Note>
                </>
              )}
              {msg && <Status ok={msg.ok} bad={!msg.ok} style={{ marginTop: ".6rem" }}>{msg.ok ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />} {msg.text}</Status>}
              <Ghost onClick={checkStatus} disabled={busy}><RefreshCw size={15} /> 상태 다시 확인</Ghost>
              <Ghost onClick={() => go(1)}><ArrowLeft size={15} /> 이전</Ghost>
            </>
          )}

          {/* STEP 3 — 클라이언트 설치 */}
          {step === 3 && (
            <>
              <StepH>3. 내 컴퓨터에 RT Remote 설치</StepH>
              {clientInstalled ? (
                <>
                  <Status ok><CheckCircle2 size={18} /> RT Remote 설치됨 — 다음으로.</Status>
                  <StepP style={{ fontSize: ".82rem" }}>실제 설치/동작은 ④단계 <b>[자동 페어링]</b>에서 자동 검증됩니다(되면 “페어링 완료!”).</StepP>
                  <Big green onClick={() => go(4)}>다음 →</Big>
                  <Ghost onClick={() => { window.location.href = "/download/RTRemote-Windows-x64.zip" }}><DownloadCloud size={15} /> 다시 받기 / 갱신</Ghost>
                </>
              ) : (
                <>
                  <StepP>접속하는 <b>내 컴퓨터</b>에 RT Remote를 한 번만 설치하면 됩니다.
                    가장 쉬운 방법은 <b>앤츠톡 → 플러그인 → RT Remote → 설치</b> 입니다(다운로드·설치 자동).</StepP>
                  <Big onClick={() => { window.location.href = "/download/RTRemote-Windows-x64.zip" }}><DownloadCloud size={18} /> RT Remote 내려받기 (Windows)</Big>
                  <StepP style={{ margin: ".9rem 0 .3rem", fontSize: ".82rem" }}>※ 받은 zip을 풀고 <Mono>RTRemote-스킴등록.bat</Mono> 한 번 실행. (앤츠톡 플러그인 설치면 이것도 자동)</StepP>
                  <Big green style={{ marginTop: ".6rem" }} onClick={markClientInstalled}>설치했어요 → 다음 →</Big>
                </>
              )}
              <Ghost onClick={() => go(2)}><ArrowLeft size={15} /> 이전</Ghost>
            </>
          )}

          {/* STEP 4 — 접속 */}
          {step === 4 && selHost && (
            <>
              <StepH>4. 접속하기 🎉</StepH>
              <StepP><b>{selHost.name}</b> — 처음이면 <b>[자동 페어링]</b> 한 번 누르고, 그다음 <b>[접속]</b>. (페어링은 이 PC에 한 번만)</StepP>
              <Big onClick={autoPair} disabled={busy} style={{ background: "var(--accent)" }}>
                {busy ? <><Spin size={18} /> 자동 페어링 중… (최대 20초)</> : <><KeyRound size={18} /> 자동 페어링 (PIN 입력 없음)</>}
              </Big>
              <Big green onClick={connect} style={{ marginTop: ".6rem" }}><Play size={18} /> {selHost.name} 에 접속</Big>
              {msg && <Status ok={msg.ok} bad={!msg.ok} style={{ marginTop: ".8rem" }}>{msg.ok ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />} {msg.text}</Status>}

              <Help>
                <HelpToggle style={{ margin: "0 auto" }} onClick={() => setShowHelp((v) => !v)}><HelpCircle size={13} /> 잘 안 되나요?</HelpToggle>
                {showHelp && (
                  <div style={{ marginTop: 8, fontSize: ".8rem", color: "#64748b", lineHeight: 1.6 }}>
                    • RT Remote 클라이언트가 최신인지 확인: <b>앤츠톡 → 플러그인 → RT Remote → [재설치/갱신]</b><br />
                    • [자동 페어링] 후 <b>“페어링 완료!”</b> 가 떠야 [접속]이 됩니다. (한 번 페어링하면 이후엔 [접속]만)
                  </div>
                )}
              </Help>
              <Ghost onClick={() => go(3)}><ArrowLeft size={15} /> 이전</Ghost>
            </>
          )}
        </Card>
      </Content>
    </Page>
  )
}

export default RtRemote
